import React from 'react';
import {
  StandardInputBaseProps,
  inputContainerStyles,
  labelStyles,
  requiredIndicatorStyles,
  getInputClassName,
} from './StandardInputStyles';
import Loading from '../Loading';

interface Props extends Omit<StandardInputBaseProps, 'label'> {
  description?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement> | undefined;
  disabled?: boolean;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement> | undefined;
  onClick?: React.MouseEventHandler<HTMLInputElement> | undefined;
  autoFocus?: boolean;
  label?: string;
}

export default function StandardInputText({
  id,
  label,
  isRequired,
  placeholderText,
  value,
  onChange,
  isLoading = false,
  disabled = false,
  description,
  onBlur,
  onKeyDown,
  onClick,
  autoFocus,
}: Props) {
  console.log('StandardInputText rendered with id:', id);
  const isDisabled = disabled || isLoading;
  return (
    <div className={inputContainerStyles}>
      {label && (
        <label htmlFor={id} className={labelStyles}>
          {label}
          {isRequired && <span className={requiredIndicatorStyles}>*</span>}
        </label>
      )}
      {description && <p className='text-sm text-text_gray_900 mt-1'>{description}</p>}

      <div className='w-full flex flex-col relative'>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          {id === 'email-input' && (
            <span
              style={{
                position: 'absolute',
                left: '12px',
                display: 'flex',
                alignItems: 'center',
                pointerEvents: 'none',
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M13.3333 2.66663H2.66668C1.9303 2.66663 1.33334 3.26358 1.33334 3.99996V12C1.33334 12.7363 1.9303 13.3333 2.66668 13.3333H13.3333C14.0697 13.3333 14.6667 12.7363 14.6667 12V3.99996C14.6667 3.26358 14.0697 2.66663 13.3333 2.66663Z'
                  stroke='#99A1AF'
                  strokeWidth='1.33333'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  d='M14.6667 4.66663L8.68668 8.46663C8.48086 8.59558 8.24289 8.66397 8.00001 8.66397C7.75713 8.66397 7.51913 8.59558 7.31334 8.46663L1.33334 4.66663'
                  stroke='#99A1AF'
                  strokeWidth='1.33333'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </span>
          )}
          <input
            type='text'
            id={id}
            placeholder={placeholderText ?? ''}
            className={getInputClassName('text')}
            style={
              id === 'email-input'
                ? {
                    textIndent: '23px',
                    paddingLeft: '36px',
                    color: 'rgba(10,10,10,0.50)',
                  }
                : {}
            }
            value={value}
            onChange={onChange}
            disabled={disabled}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
            onClick={onClick}
            autoFocus={autoFocus}
          />
        </div>

        {isLoading && (
          <div className='absolute top-0 left-0 z-10 w-full h-full flex items-center justify-center bg-surface_gray_50 opacity-70'>
            <Loading
              text=''
              loadingClass={'max-h-[150px] max-w-[150px] w-8 h-8 z-20'}
              textClass='z-20'
            />
          </div>
        )}
      </div>
    </div>
  );
}
